<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="waybillCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      @checkbox-change="getSelectCount()"
      @checkbox-all="getSelectCount()"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:waybillNo="{ row }">
        <div>
          <el-link
            type="primary"
            @click="openDetailPageDialog(row.waybillCode)"
          >
            {{ row.waybillNo }}
          </el-link>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          content="取消派单"
          v-allow="'actCancelSendWaybill'"
          placement="top"
        >
          <i class="el-icon-refresh-left tool-btn" @click="cancel(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="运单打印"
          v-allow="'actPrintWaybill'"
          placement="top"
        >
          <i
            class="el-icon-printer tool-btn"
            @click="print(row.waybillCode)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: {  },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      fullScreenLoading: false,
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },

    print(code) {
      this.selectList = []
      this.selectList.push(code)
      this.$api.printPDF('/order/waybill/print', {
        listWaybillCode: this.selectList,
      })
    },
    async batchPrint() {
      const selectCode = await this.getSelectData('code')
      if (!selectCode) {
        return
      }
      this.commitPrint()
    },
    async batchExport() {
      const selectCode = await this.getSelectData('code')
      if (!selectCode) {
        return
      }
      return this.selectList
    },
    cancel(row) {
      this.selectList = []
      this.selectList.push(row.waybillCode)
      this.$confirm('确认要对当前的运输单，进行取消派车操作吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.commitCancel()
      })
    },
    async batchCancel() {
      const selectCode = await this.getSelectData('code')
      if (!selectCode) {
        return
      }
      this.$confirm('确认要对选中的运输单，进行取消派车操作吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.commitCancel()
      })
    },
    commitCancel() {
      this.$api
        .bizWaybillCancelSendApi({
          listWaybillCode: this.selectList,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
    },
    commitPrint() {
      this.$api.printPDF('/order/waybill/print', {
        listWaybillCode: this.selectList,
      })
    },
    getSelectData(selectType) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的运输单')
        return false
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      return true
    },
    openDetailPageDialog(no) {
      this.$router.push({
        name: 'carriage-waybill-detail-page',
        params: { no },
      })
    },
    getSelectCount(){
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      this.$emit('updateTotCount', totCount)
    },
  },
}
</script>
